
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacyUrl",
      function () {
        return require("private-next-pages/privacyUrl.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacyUrl"])
      });
    }
  